"use strict";
var PromiseObservable_1 = require('./PromiseObservable');
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/node_modules/_rxjs@5.5.12@rxjs/observable/fromPromise.js
// module id = ../../../../_rxjs@5.5.12@rxjs/observable/fromPromise.js
// module chunks = vendor